import { render, staticRenderFns } from "./BasicInfoHeader.vue?vue&type=template&id=8ece4f9c"
import script from "./BasicInfoHeader.vue?vue&type=script&lang=js"
export * from "./BasicInfoHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports